// extracted by mini-css-extract-plugin
export default {"tooltip":"item-with-dual-font-options-module__tooltip--XvCz6"};